import {
  billingMethodAlertOptions,
  billingMethodOptions
} from 'components/practice/Settings/components/HealthcareProgram/components/PaymentProgramTab/components/PaymentSettings/components/PerPhaseConfiguration/components/OutOfNetwork/lib/helpers';
import { Alert } from 'components/shared/Alert/Alert';
import Badge from 'components/shared/Badge/Badge';
import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

const BillingMethod = ({ value, onChange }) => {
  const activeOption = value?.route_to;
  const config = value?.config ?? {};

  const handleRouteTo = (route_to) =>
    onChange({ route_to, config: route_to === activeOption ? config : {} });
  const handleConfig = (patch) =>
    onChange({ route_to: activeOption, config: { ...config, ...patch } });

  const renderChildren = (optionValue) => {
    if (optionValue === 'down-payment') {
      return (
        <div className="flex flex-col gap-4 px-1">
          <CurrencyInput
            label="Down payment amount"
            onValueChange={(next) => handleConfig({ down_payment_amount: Number(next) || 0 })}
            value={config.down_payment_amount ?? 0}
            className="max-w-[406px]"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Typography variant="label" size="large" weight="medium">
          Billing method
        </Typography>
        <Typography variant="p" size="small">
          Choose how patient responsibility is determined for OON visits.
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        {billingMethodOptions.map((option) => {
          const isActive = option.value === activeOption;
          const children = renderChildren(option.value);
          return (
            <Disclosure
              key={option.value}
              isOpen={isActive}
              onToggle={() => handleRouteTo(option.value)}
              customTitle={
                <div className="flex gap-2">
                  <Typography variant="p" size="small" weight="medium">
                    {option.title}
                  </Typography>
                  {option.recommended && (
                    <Badge text="Recommended" variant="lighter" color="primary" size="small" />
                  )}
                </div>
              }
              disableOpen={!children}
              caption={option.caption}
              className="w-full"
              buttonClassName="py-2"
              bodyClassName="flex-col gap-0"
              radio>
              {children}
            </Disclosure>
          );
        })}
      </div>
      <Typography variant="p" size="small" weight="medium">
        Using out-of-network benefits
      </Typography>
      <Alert
        title="The patient's out-of-network benefits will be used to calculate their estimated responsibility. The system pulls real-time eligibility data and applies:"
        message={
          <span className="flex flex-col gap-1 text-sm">
            {billingMethodAlertOptions.map((item) => {
              return (
                <span
                  key={item.title}
                  className="flex gap-2 text-sm leading-[22px] text-neutral-700">
                  <span aria-hidden="true">•</span>
                  <span>
                    <span className="font-semibold">{item.title}</span>
                    {item.description && <> — {item.description}</>}
                  </span>
                </span>
              );
            })}
          </span>
        }
        icon="bulb-filled"
        variant="lighter"
        className="w-full"
      />
    </div>
  );
};

export default BillingMethod;
